<template>
  <b-card no-body class="p-2">
    <h3 class="mb-2">
      {{
        jobLaboralFunction.puestoFuncionLaboralId == 0
          ? $t("Routes.JobLaboralFunctionAdd")
          : $t("Routes.JobLaboralFunctionEdit")
      }}
    </h3>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('humanResources.jobLaboralFunction.columns.job')"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.jobLaboralFunction.columns.job')"
                :state="errors.length > 0 ? false : null"
              >
                <v-select
                  id="Puesto"
                  v-model="jobLaboralFunction.puestoId"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="nombre"
                  :options="jobs"
                  :reduce="(option) => option.puestoId"
                  @search="searchJobs"
                />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('humanResources.jobLaboralFunction.columns.laboralFunction')"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.jobLaboralFunction.columns.laboralFunction')"
                :state="errors.length > 0 ? false : null"
              >
                <v-select
                  id="Puesto"
                  v-model="jobLaboralFunction.funcionLaboralId"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="texto"
                  :options="laboralFunctions"
                  :reduce="(option) => option.id"
                />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="float-right mt-2 mb-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            <b-spinner v-if="addingJobLaboralFunction" small class="mr-1" />
            {{ jobLaboralFunction.puestoFuncionLaboralId == 0 ? $t("Lists.Add") : $t("Lists.Edit") }}
          </b-button>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,

  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import humanResources from '@/services/humanresources.service'
import optionService from '@/services/option.service'
import vSelect from 'vue-select'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required } from '@validations'
import router from '@/router'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInvalidFeedback,
    BFormGroup,
    BButton,
    BSpinner,

    ValidationProvider,
    ValidationObserver,

    vSelect,
  },
  setup() {
    const jobs = ref([])
    const laboralFunctions = ref([])
    const addingJobLaboralFunction = ref(false)
    const jobLaboralFunction = ref({
      puestoFuncionLaboralId: 0,
      puestoId: 0,
      funcionLaboralId: 0,
    })

    const blankJobLaboralFunction = {
      puestoFuncionLaboralId: 0,
      puestoId: 0,
      funcionLaboralId: 0,
    }

    const {
      fetchJobLaboralFunction,
      createJobLaboralFunction,
      updateJobLaboralFunction,
      fetchJobs,
    } = humanResources()

    const {
      fetchOptions,
    } = optionService()

    const resetJobLaboralFunction = () => {
      jobLaboralFunction.value = JSON.parse(JSON.stringify(blankJobLaboralFunction))
    }

    if (router.currentRoute.params.puestoFuncionLaboralId) {
      fetchJobLaboralFunction(router.currentRoute.params.puestoFuncionLaboralId, data => {
        jobLaboralFunction.value = data
      })
    } else {
      jobLaboralFunction.value = JSON.parse(JSON.stringify(blankJobLaboralFunction))
    }
    fetchOptions({ nombreDominio: 'RecursosHumanosFuncionLaboral' }, data => {
      laboralFunctions.value = data
    })
    const searchJobs = text => {
      fetchJobs({ searchQuery: text, limit: 50 }, data => {
        jobs.value = data.puestos
      })
    }
    fetchJobs({ limit: 50 }, data => {
      jobs.value = data.puestos
    })
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetJobLaboralFunction)

    const onSubmit = () => {
      addingJobLaboralFunction.value = true
      if (jobLaboralFunction.value.puestoFuncionLaboralId === 0) {
        createJobLaboralFunction(jobLaboralFunction.value, () => {
          addingJobLaboralFunction.value = false
          router.push({ name: 'apps-human-resources-job-laboral-function-list' })
        })
      } else {
        updateJobLaboralFunction(jobLaboralFunction.value.puestoFuncionLaboralId, jobLaboralFunction.value, () => {
          addingJobLaboralFunction.value = false
          router.push({ name: 'apps-human-resources-job-laboral-function-list' })
        })
      }
    }

    return {
      jobs,
      laboralFunctions,
      jobLaboralFunction,
      addingJobLaboralFunction,
      required,
      getValidationState,
      refFormObserver,
      resetForm,
      onSubmit,
      searchJobs,

    }
  },
}
</script>
